import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, Circle, AlertTriangle, ChevronRight } from 'lucide-react';
import { computeSetupSteps } from '../../utils/setupReadiness';
import './setup-checklist.css';

/**
 * First-run setup checklist for the Dashboard.
 * Drives merchants toward publishing. Hidden once the widget is live.
 */
const SetupChecklist = ({ settings, widgetStatus, onNavigate }) => {
  const { t } = useTranslation();
  const { steps, completedCount, totalCount, requiredComplete, live } = computeSetupSteps(
    settings,
    widgetStatus,
  );

  if (live) return null;

  const pct = totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;

  return (
    <section className="q2c-setup" aria-label={t('settings.checklist.ariaLabel')}>
      <div className="q2c-setup-head">
        <div>
          <h3 className="q2c-setup-title">{t('settings.checklist.title')}</h3>
          <p className="q2c-setup-sub">
            {requiredComplete
              ? t('settings.checklist.subDone')
              : t('settings.checklist.subTodo')}
          </p>
        </div>
        <div className="q2c-setup-progress-wrap" aria-hidden="true">
          <div className="q2c-setup-progress-label">
            {completedCount} / {totalCount}
          </div>
          <div className="q2c-setup-progress-track">
            <div className="q2c-setup-progress-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>
      </div>

      <ul className="q2c-setup-list">
        {steps.map((step) => {
          const Icon = step.complete ? CheckCircle2 : step.required ? AlertTriangle : Circle;
          const stateClass = step.complete
            ? 'is-complete'
            : step.required
              ? 'is-required'
              : 'is-optional';
          return (
            <li key={step.id}>
              <button
                type="button"
                className={`q2c-setup-item ${stateClass}`}
                onClick={() => onNavigate?.(step.route)}
              >
                <Icon size={18} className="q2c-setup-item-icon" />
                <span className="q2c-setup-item-main">
                  <span className="q2c-setup-item-label">
                    {t(step.labelKey)}
                    {!step.required && <span className="q2c-setup-badge">{t('settings.checklist.optional')}</span>}
                  </span>
                  {!step.complete && <span className="q2c-setup-item-reason">{t(step.reasonKey)}</span>}
                </span>
                <ChevronRight size={16} className="q2c-setup-item-chevron" />
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SetupChecklist;
